"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
exports.artifactType = 'userInputNeeded';
// Zod schema + new config type
exports.NodeConfigSchema = zod_1.z
    .object({
    inputType: finley_types_1.DbTable.UserInputTypeSchema.describe('Type of user input required'),
})
    .describe('Configuration for userInputNeeded node');
// Zod schema + new node type
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
})
    .extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    loanProductSlug: zod_1.z.string().nullable(),
    creditFacilitySlug: zod_1.z.string().nullable(),
    configuration: exports.NodeConfigSchema,
})
    .describe('Schema for userInputNeeded DB record');
//# sourceMappingURL=node.js.map